import type { FaireProductEntity } from "../../entity_types/product";

export const p_dt9rsf6nx6: FaireProductEntity = {
  token: "p_dt9rsf6nx6",
  type: "product",
  name: "Block Printed Smock Dress (Paloma: Mulberry Bloom)",
  brandToken: "b_ck3ocbab9u",
  brandName: "The Fox and The Mermaid",
  imageUrl:
    "https://cdn.faire.com/fastly/e7f4b9314e313f8bf79edf9cf0ad3354b3a84bc908beaabfe9112e65dfd1db26.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1cab0efbe86d9a87d12c98b2461c9c170d5f5dca336c00b84d6f63c921e994d4.png",
    "https://cdn.faire.com/fastly/5819e629b15cb1971d51b8a5651e66e14a315b872aee4279982cdb768893d2eb.png",
    "https://cdn.faire.com/fastly/d5fdb3fcce9dd89c553f376b1bd5421f5a47f15001473c5670c3d8c10a977f22.jpeg",
  ],
  priceDollars: 69,
  description:
    "Introducing the Paloma block printed maxi in Mulberry Bloom, perfect for fall. The bust features delicate smocking, the sleeves are elasticated and can be worn on or off the shoulder. It comes with a detachable belt. \n\n*100% cotton\n*Pockets\n*Block Printed by artisans in Jaipur, India\n*Detachable belt\n*Can be worn on or off the shoulders\n*Hand wash when possible or machine was on cold. Do not soak.\n\n\nSIZING:\n\nBust:\n\nS: stretches to 40  inches\n\nM: stretches to 42 inches\n\nL: stretches to 44 inches\n\nXL: stretches to 46 inches\n\nLength:\n\n53 Inches\n\nfall 2026 dresses, 2026 fashion, labor day dresses, party dresses, boho dress, off the shoulder dress, floral maxi dress, purple dress, ",
  tags: [],
  msrpDollars: 145,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:34.150Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
